import React from 'react';
import { AppInput, AppInputProps } from '../app-input';

export const AppHeightInput: React.FC<React.PropsWithChildren<AppInputProps>> = (props) => {
  return <AppInput {...props} type={'number'} disableClearable={true} />;
};
